export default __webpack_public_path__ + "static/illustration-b5e8b2ced94f3aeee1153efbabe20137.png";